import { service } from "@server/client";
import type {
  GetAccountOrdersQuery,
  GetAccountOrdersQueryVariables,
} from "@server/gql/graphql";
import { getAccountOrdersQuery } from "@server/queries/account";

export const getAccountOrders = async ({ token }: { token: string }) => {
  try {
    const response = await service<
      GetAccountOrdersQuery,
      GetAccountOrdersQueryVariables
    >({
      query: getAccountOrdersQuery,
      variables: {
        token,
      },
    });
    if (response.getAccountOrders.__typename === "OrderResponseItemsDto") {
      return {
        ok: true,
        data: response.getAccountOrders,
        error: null,
      };
    }
    if (response.getAccountOrders.__typename === "ProblemDetails") {
      return {
        ok: false,
        data: null,
        error: response.getAccountOrders,
      };
    }
    return {
      ok: false,
      data: null,
      error: null,
    };
  } catch (e: any) {
    console.group(
      ...e.response.errors.map((err: any) => console.debug(err)),
      console.debug("(in getAccountOrders)"),
    );
    return {
      ok: false,
      data: null,
      error: null,
    };
  }
};
